import ModalWrapper from "../ModalWrapper/ModalWrapper";
import { useEffect, useRef, useState } from "react";
import styles from "./CategoriesModal.module.scss";
import { useQuery } from "react-query";
import useAPI from "hooks/useAPI";
import { useLocation, useNavigate } from "react-router-dom";
import Sitemap from "routes/sitemap";
import desktopStyles from "../../../../pages/Catalogue/Aside/CatalogueAside.module.scss";

const addCategoryPaths = (category, parentPath = "") => {
    const path = `${parentPath}/${category.slug}`;
    return { ...category, path, children: (category.children ?? []).map((child) => addCategoryPaths(child, path)) };
};

const Chevron = () => (
    <svg className={styles.chevron} viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="m7.5 4.5 5.5 5.5-5.5 5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CategoriesModal = ({ openModal, setOpenModal, sideRail }) => {
    const [categoryTrail, setCategoryTrail] = useState([]);
    const listRef = useRef(null);
    const api = useAPI();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const { data } = useQuery(["Products.CategoryTree"], () => api.get("/categories/product/tree"));

    const categories = Array.isArray(data) ? data.map((category) => addCategoryPaths(category)) : [];
    const selectedCategory = categoryTrail[categoryTrail.length - 1];
    const visibleCategories = selectedCategory?.children ?? categories;

    useEffect(() => {
        if (!openModal) setCategoryTrail([]);
    }, [openModal]);

    useEffect(() => {
        if (listRef.current) listRef.current.scrollTop = 0;
    }, [categoryTrail]);

    const openCategory = (category) => {
        navigate(`${Sitemap.catalogue.category}${category.path}`);
        setCategoryTrail([]);
        setOpenModal(false);
    };

    const selectCategory = (category) => {
        if (category.children?.length > 0) {
            setCategoryTrail((trail) => [...trail, category]);
        } else {
            openCategory(category);
        }
    };

    return (
        <ModalWrapper
            openModal={openModal}
            setOpenModal={setOpenModal}
            title="Kategorije"
            sideDrawer
            sideRail={sideRail}
            compactHeader={Boolean(selectedCategory)}
            headerContent={selectedCategory ? (
                <div className={`${desktopStyles.backRow} ${styles.desktopBackRow}`}>
                    <button type="button" className={`${desktopStyles.backButton} ${styles.mobileBackButton}`} onClick={() => setCategoryTrail((trail) => trail.slice(0, -1))}>
                        <span className={desktopStyles.backIcon}>
                            <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="m12.5 4.5-5.5 5.5 5.5 5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <span className={desktopStyles.backText}>Nazad</span>
                    </button>
                    <button type="button" className={`${desktopStyles.allCategoryButton} ${styles.mobileAllButton}`} onClick={() => openCategory(selectedCategory)} aria-label={`Svi proizvodi iz kategorije ${selectedCategory.name}`}>
                        Sve
                    </button>
                </div>
            ) : undefined}
        >
            <div className={styles.panelContent}>
                {selectedCategory ? (
                    <div className={desktopStyles.drillHeader}>
                        <div className={desktopStyles.currentCategory}>{selectedCategory.name}</div>
                    </div>
                ) : null}

                <ul ref={listRef} key={selectedCategory?.id ?? "root"} className={styles.categoryList}>
                    {visibleCategories.map((category) => {
                        const categoryUrl = `${Sitemap.catalogue.category}${category.path}`;
                        const isActive = pathname === categoryUrl || pathname.startsWith(`${categoryUrl}/`);
                        return (
                            <li key={category.id} className={styles.categoryItem}>
                                <button type="button" className={`${styles.categoryButton} ${isActive ? styles.active : ""}`} onClick={() => selectCategory(category)} aria-current={pathname === categoryUrl ? "page" : undefined}>
                                    <span>{category.name}</span>
                                    {category.children?.length > 0 && <Chevron />}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </ModalWrapper>
    );
};

export default CategoriesModal;
